import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-prompt-modal',
  templateUrl: './prompt-modal.component.html',
  styleUrls: ['./prompt-modal.component.scss'],
  standalone: false,
})
export class PromptModalComponent implements OnInit {
  public title: string;
  public label: string;
  public description: string = '';
  public placeholder: string = '';
  public promptValue: string = '';
  public acceptText: string = 'Crear';
  public cancelText: string = 'Cancelar';
  public icon: string = 'group_add';
  public multiline: boolean = false;
  public required: boolean = true;
  public rows: number = 4;

  constructor(
    public dialog: MatDialogRef<PromptModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.title = this.data.title;
    this.label = this.data.label;
    this.description = this.data.description ?? '';
    this.placeholder = this.data.placeholder ?? '';
    this.promptValue = this.data.initialValue ?? '';
    this.acceptText = this.data.acceptText ?? 'Crear';
    this.cancelText = this.data.cancelText ?? 'Cancelar';
    this.icon = this.data.icon ?? 'group_add';
    this.multiline = this.data.multiline ?? false;
    this.required = this.data.required ?? true;
    this.rows = this.data.rows ?? 4;
  }

  get isSubmitDisabled(): boolean {
    return this.required && !this.promptValue.trim();
  }

  close() {
    this.dialog.close(false);
  }

  accept() {
    this.dialog.close(this.promptValue.trim());
  }
}
